export default __webpack_public_path__ + "static/media/stock.2855f83d.svg";